import { LoginResponse } from '@Services/auth/auth.res.types';
import api from '@Services/api';
export const loginRequest = async (email: string, password: string) =>
	await api.post<LoginResponse>('auth/login', {
		email,
		password,
	});
